export enum LanguagesEnum {
  de = 'de',
  fr = 'fr',
  it = 'it',
  en = 'en',
}
